(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'd2v-path-js', 'd2v-color-js', 'd2v-interpolate-js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('d2v-path-js'), require('d2v-color-js'), require('d2v-interpolate-js'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'd2v-viz-js'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'd2v-viz-js'.");
    }
    if (typeof this['d2v-path-js'] === 'undefined') {
      throw new Error("Error loading module 'd2v-viz-js'. Its dependency 'd2v-path-js' was not found. Please, check whether 'd2v-path-js' is loaded prior to 'd2v-viz-js'.");
    }
    if (typeof this['d2v-color-js'] === 'undefined') {
      throw new Error("Error loading module 'd2v-viz-js'. Its dependency 'd2v-color-js' was not found. Please, check whether 'd2v-color-js' is loaded prior to 'd2v-viz-js'.");
    }
    if (typeof this['d2v-interpolate-js'] === 'undefined') {
      throw new Error("Error loading module 'd2v-viz-js'. Its dependency 'd2v-interpolate-js' was not found. Please, check whether 'd2v-interpolate-js' is loaded prior to 'd2v-viz-js'.");
    }
    root['d2v-viz-js'] = factory(typeof this['d2v-viz-js'] === 'undefined' ? {} : this['d2v-viz-js'], kotlin, this['d2v-path-js'], this['d2v-color-js'], this['d2v-interpolate-js']);
  }
}(this, function (_, Kotlin, $module$d2v_path_js, $module$d2v_color_js, $module$d2v_interpolate_js) {
  'use strict';
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var drop = Kotlin.kotlin.collections.drop_ba2ldo$;
  var throwCCE = Kotlin.throwCCE;
  var Unit = Kotlin.kotlin.Unit;
  var toMutableList = Kotlin.kotlin.collections.toMutableList_4c7yge$;
  var PropertyMetadata = Kotlin.PropertyMetadata;
  var to = Kotlin.kotlin.to_ujzrz7$;
  var joinToString = Kotlin.kotlin.collections.joinToString_fmv235$;
  var Enum = Kotlin.kotlin.Enum;
  var throwISE = Kotlin.throwISE;
  var ensureNotNull = Kotlin.ensureNotNull;
  var dropLast = Kotlin.kotlin.text.dropLast_6ic1pp$;
  var Kind_INTERFACE = Kotlin.Kind.INTERFACE;
  var PathAdapter = $module$d2v_path_js.io.data2viz.path.PathAdapter;
  var asList = Kotlin.org.w3c.dom.asList_kt9thq$;
  var equals = Kotlin.equals;
  var throwUPAE = Kotlin.throwUPAE;
  var toString = Kotlin.toString;
  var get_color = $module$d2v_color_js.io.data2viz.color.get_color_pdl1vz$;
  var Color = $module$d2v_color_js.io.data2viz.color.Color;
  var interpolateRgb = $module$d2v_interpolate_js.io.data2viz.interpolate.interpolateRgb_ch2ih4$;
  var LinearGradient = $module$d2v_color_js.io.data2viz.color.LinearGradient;
  var RadialGradient = $module$d2v_color_js.io.data2viz.color.RadialGradient;
  var toDouble = Kotlin.kotlin.text.toDouble_pdl1vz$;
  var IllegalArgumentException_init = Kotlin.kotlin.IllegalArgumentException_init_pdl1vj$;
  var defineInlineFunction = Kotlin.defineInlineFunction;
  var wrapFunction = Kotlin.wrapFunction;
  var SvgPath = $module$d2v_path_js.io.data2viz.path.SvgPath;
  var mapOf = Kotlin.kotlin.collections.mapOf_x2b85n$;
  ClassSelector.prototype = Object.create(Selector.prototype);
  ClassSelector.prototype.constructor = ClassSelector;
  Combinator.prototype = Object.create(Enum.prototype);
  Combinator.prototype.constructor = Combinator;
  TypeSelector.prototype = Object.create(Selector.prototype);
  TypeSelector.prototype.constructor = TypeSelector;
  StateManagerStatus.prototype = Object.create(Enum.prototype);
  StateManagerStatus.prototype.constructor = StateManagerStatus;
  TextAnchor.prototype = Object.create(Enum.prototype);
  TextAnchor.prototype.constructor = TextAnchor;
  TextAlignmentBaseline.prototype = Object.create(Enum.prototype);
  TextAlignmentBaseline.prototype.constructor = TextAlignmentBaseline;
  function SelectionEnterAccessor(index, element, datum) {
    this.index = index;
    this.element = element;
    this.datum = datum;
  }
  SelectionEnterAccessor.$metadata$ = {kind: Kind_CLASS, simpleName: 'SelectionEnterAccessor', interfaces: []};
  function SelectionUpdateAccessor(index, element, datum) {
    this.index = index;
    this.element = element;
    this.datum = datum;
  }
  SelectionUpdateAccessor.$metadata$ = {kind: Kind_CLASS, simpleName: 'SelectionUpdateAccessor', interfaces: []};
  function SelectionExitAccessor(element) {
    this.element = element;
  }
  SelectionExitAccessor.$metadata$ = {kind: Kind_CLASS, simpleName: 'SelectionExitAccessor', interfaces: []};
  function Selection(selectedElements, data, creator) {
    this.data = data;
    this.creator = creator;
    this.elements = toMutableList(selectedElements);
    this.onEnter = Selection$onEnter$lambda;
    this.onUpdate = Selection$onUpdate$lambda;
    this.onExit = Selection$onExit$lambda;
  }
  var emptyList = Kotlin.kotlin.collections.emptyList_287e2$;
  Selection.prototype.processEnterUpdateExit = function () {
    var enterdata = this.elements.size < this.data.size ? drop(this.data, this.elements.size) : emptyList();
    var exitElements = this.data.size < this.elements.size ? drop(this.elements, this.data.size) : emptyList();
    var tmp$, tmp$_0;
    var index = 0;
    tmp$ = enterdata.iterator();
    while (tmp$.hasNext()) {
      var item = tmp$.next();
      var index_0 = (tmp$_0 = index, index = tmp$_0 + 1 | 0, tmp$_0);
      var tmp$_1;
      var element = this.creator();
      this.onEnter(new SelectionEnterAccessor(index_0, Kotlin.isType(tmp$_1 = element, VizElement) ? tmp$_1 : throwCCE(), item));
      this.elements.add_11rb$(element);
    }
    var tmp$_2, tmp$_0_0;
    var index_1 = 0;
    tmp$_2 = this.data.iterator();
    while (tmp$_2.hasNext()) {
      var item_0 = tmp$_2.next();
      var i = (tmp$_0_0 = index_1, index_1 = tmp$_0_0 + 1 | 0, tmp$_0_0);
      this.onUpdate(new SelectionUpdateAccessor(i, this.elements.get_za3lpa$(i), item_0));
    }
    var tmp$_3, tmp$_0_1;
    var index_2 = 0;
    tmp$_3 = exitElements.iterator();
    while (tmp$_3.hasNext()) {
      var item_1 = tmp$_3.next();
      index_2 = index_2 + 1 | 0;
      this.onExit(new SelectionExitAccessor(item_1));
    }
  };
  function Selection$onEnter$lambda($receiver) {
    return Unit;
  }
  function Selection$onUpdate$lambda($receiver) {
    return Unit;
  }
  function Selection$onExit$lambda($receiver) {
    return Unit;
  }
  Selection.$metadata$ = {kind: Kind_CLASS, simpleName: 'Selection', interfaces: []};
  var circle;
  var line;
  var rect;
  var text;
  var axis;
  var axis_metadata = new PropertyMetadata('axis');
  var ticks;
  var ticks_metadata = new PropertyMetadata('ticks');
  var blue;
  var blue_metadata = new PropertyMetadata('blue');
  function cssclass() {
    return new CssClassDelegate();
  }
  function CssClassDelegate() {
  }
  CssClassDelegate.prototype.getValue_n5byny$ = function (from, property) {
    return new CssClass(property.callableName);
  };
  CssClassDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'CssClassDelegate', interfaces: []};
  function CssClass(name) {
    this.name = name;
  }
  CssClass.$metadata$ = {kind: Kind_CLASS, simpleName: 'CssClass', interfaces: []};
  CssClass.prototype.component1 = function () {
    return this.name;
  };
  CssClass.prototype.copy_61zpoe$ = function (name) {
    return new CssClass(name === void 0 ? this.name : name);
  };
  CssClass.prototype.toString = function () {
    return 'CssClass(name=' + Kotlin.toString(this.name) + ')';
  };
  CssClass.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.name) | 0;
    return result;
  };
  CssClass.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.name, other.name))));
  };
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  function Selector() {
    this.parent = null;
    this.selectors = ArrayList_init();
  }
  Selector.prototype.copyParentAndSelectors_83yxxp$ = function (to_0) {
    var tmp$;
    if ((tmp$ = this.parent) != null) {
      to_0.parent = to(tmp$.first, tmp$.second);
    }
    var tmp$_0;
    tmp$_0 = this.selectors.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      to_0.selectors.add_11rb$(element.copy());
    }
  };
  Selector.prototype.children_3e1x6w$ = function (rightSelector) {
    var tmp$;
    var copy = rightSelector.copy();
    copy.parent = to(this.copy(), Combinator$CHILDREN_getInstance());
    return Kotlin.isType(tmp$ = copy, TypeSelector) ? tmp$ : throwCCE();
  };
  Selector.$metadata$ = {kind: Kind_CLASS, simpleName: 'Selector', interfaces: []};
  function ClassSelector(name) {
    Selector.call(this);
    this.name = name;
  }
  ClassSelector.prototype.copy = function () {
    var copy = new ClassSelector(this.name);
    this.copyParentAndSelectors_83yxxp$(copy);
    return copy;
  };
  ClassSelector.prototype.toString = function () {
    return '.' + this.name + joinToString(this.selectors, '');
  };
  ClassSelector.prototype.c_vocsil$ = function (cssClass) {
    var tmp$;
    var copy = this.copy();
    copy.selectors.add_11rb$(new ClassSelector(cssClass.name));
    return Kotlin.isType(tmp$ = copy, ClassSelector) ? tmp$ : throwCCE();
  };
  ClassSelector.$metadata$ = {kind: Kind_CLASS, simpleName: 'ClassSelector', interfaces: [Selector]};
  ClassSelector.prototype.component1 = function () {
    return this.name;
  };
  ClassSelector.prototype.copy_61zpoe$ = function (name) {
    return new ClassSelector(name === void 0 ? this.name : name);
  };
  ClassSelector.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.name) | 0;
    return result;
  };
  ClassSelector.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.name, other.name))));
  };
  function Combinator(name, ordinal, asText) {
    Enum.call(this);
    this.asText = asText;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Combinator_initFields() {
    Combinator_initFields = function () {
    };
    Combinator$CHILDREN_instance = new Combinator('CHILDREN', 0, '>');
    Combinator$DESCENDENT_instance = new Combinator('DESCENDENT', 1, ' ');
  }
  var Combinator$CHILDREN_instance;
  function Combinator$CHILDREN_getInstance() {
    Combinator_initFields();
    return Combinator$CHILDREN_instance;
  }
  var Combinator$DESCENDENT_instance;
  function Combinator$DESCENDENT_getInstance() {
    Combinator_initFields();
    return Combinator$DESCENDENT_instance;
  }
  Combinator.$metadata$ = {kind: Kind_CLASS, simpleName: 'Combinator', interfaces: [Enum]};
  function Combinator$values() {
    return [Combinator$CHILDREN_getInstance(), Combinator$DESCENDENT_getInstance()];
  }
  Combinator.values = Combinator$values;
  function Combinator$valueOf(name) {
    switch (name) {
      case 'CHILDREN':
        return Combinator$CHILDREN_getInstance();
      case 'DESCENDENT':
        return Combinator$DESCENDENT_getInstance();
      default:throwISE('No enum constant io.data2viz.viz.Combinator.' + name);
    }
  }
  Combinator.valueOf_61zpoe$ = Combinator$valueOf;
  function TypeSelector(prototype) {
    Selector.call(this);
    this.prototype = prototype;
  }
  Object.defineProperty(TypeSelector.prototype, 'name', {get: function () {
    return ensureNotNull(Kotlin.getKClassFromExpression(this.prototype).simpleName);
  }});
  TypeSelector.prototype.copy = function () {
    var copy = new TypeSelector(this.prototype);
    this.copyParentAndSelectors_83yxxp$(copy);
    return copy;
  };
  TypeSelector.prototype.c_vocsil$ = function (cssClass) {
    var tmp$;
    var copy = this.copy();
    copy.selectors.add_11rb$(new ClassSelector(cssClass.name));
    return Kotlin.isType(tmp$ = copy, TypeSelector) ? tmp$ : throwCCE();
  };
  TypeSelector.prototype.asText = function () {
    var tmp$, tmp$_0;
    return ((tmp$_0 = (tmp$ = this.parent) != null ? tmp$.first.toString() + ' ' + tmp$.second.asText + ' ' : null) != null ? tmp$_0 : '') + dropLast(this.name, 'Jfx'.length) + joinToString(this.selectors, '');
  };
  TypeSelector.prototype.toString = function () {
    return this.asText();
  };
  TypeSelector.$metadata$ = {kind: Kind_CLASS, simpleName: 'TypeSelector', interfaces: [Selector]};
  function StateManagerStatus(name, ordinal) {
    Enum.call(this);
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function StateManagerStatus_initFields() {
    StateManagerStatus_initFields = function () {
    };
    StateManagerStatus$REST_instance = new StateManagerStatus('REST', 0);
    StateManagerStatus$RECORD_instance = new StateManagerStatus('RECORD', 1);
    StateManagerStatus$UPDATE_PROPERTIES_instance = new StateManagerStatus('UPDATE_PROPERTIES', 2);
  }
  var StateManagerStatus$REST_instance;
  function StateManagerStatus$REST_getInstance() {
    StateManagerStatus_initFields();
    return StateManagerStatus$REST_instance;
  }
  var StateManagerStatus$RECORD_instance;
  function StateManagerStatus$RECORD_getInstance() {
    StateManagerStatus_initFields();
    return StateManagerStatus$RECORD_instance;
  }
  var StateManagerStatus$UPDATE_PROPERTIES_instance;
  function StateManagerStatus$UPDATE_PROPERTIES_getInstance() {
    StateManagerStatus_initFields();
    return StateManagerStatus$UPDATE_PROPERTIES_instance;
  }
  StateManagerStatus.$metadata$ = {kind: Kind_CLASS, simpleName: 'StateManagerStatus', interfaces: [Enum]};
  function StateManagerStatus$values() {
    return [StateManagerStatus$REST_getInstance(), StateManagerStatus$RECORD_getInstance(), StateManagerStatus$UPDATE_PROPERTIES_getInstance()];
  }
  StateManagerStatus.values = StateManagerStatus$values;
  function StateManagerStatus$valueOf(name) {
    switch (name) {
      case 'REST':
        return StateManagerStatus$REST_getInstance();
      case 'RECORD':
        return StateManagerStatus$RECORD_getInstance();
      case 'UPDATE_PROPERTIES':
        return StateManagerStatus$UPDATE_PROPERTIES_getInstance();
      default:throwISE('No enum constant io.data2viz.viz.StateManagerStatus.' + name);
    }
  }
  StateManagerStatus.valueOf_61zpoe$ = StateManagerStatus$valueOf;
  function StateProperty() {
  }
  StateProperty.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'StateProperty', interfaces: []};
  function VizContext() {
  }
  VizContext.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'VizContext', interfaces: [Group]};
  function VizElement() {
  }
  VizElement.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'VizElement', interfaces: []};
  function StateableElement() {
  }
  StateableElement.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'StateableElement', interfaces: []};
  function Group() {
  }
  Group.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Group', interfaces: [VizElement, StyledElement, Transformable]};
  function Transformable() {
  }
  Transformable.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Transformable', interfaces: []};
  function Transform() {
  }
  Transform.prototype.translate_lu1900$ = function (x, y, callback$default) {
    if (x === void 0)
      x = 0.0;
    if (y === void 0)
      y = 0.0;
    callback$default ? callback$default(x, y) : this.translate_lu1900$$default(x, y);
  };
  Transform.prototype.rotate_yvo9jy$ = function (degrees, x, y, callback$default) {
    if (x === void 0)
      x = 0.0;
    if (y === void 0)
      y = 0.0;
    callback$default ? callback$default(degrees, x, y) : this.rotate_yvo9jy$$default(degrees, x, y);
  };
  Transform.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Transform', interfaces: []};
  function StyledElement() {
  }
  StyledElement.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'StyledElement', interfaces: []};
  function PathVizElement() {
  }
  PathVizElement.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'PathVizElement', interfaces: [PathAdapter, Shape, VizElement]};
  function Circle() {
  }
  Circle.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Circle', interfaces: [StateableElement, StyledElement, Transformable, Shape, VizElement]};
  function Line() {
  }
  Line.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Line', interfaces: [StyledElement, Transformable, Shape, VizElement]};
  function Rect() {
  }
  Rect.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Rect', interfaces: [StateableElement, StyledElement, Transformable, Shape, VizElement]};
  function Text() {
  }
  Text.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Text', interfaces: [StyledElement, HasFill, Transformable, VizElement]};
  function TextAnchor(name, ordinal) {
    Enum.call(this);
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function TextAnchor_initFields() {
    TextAnchor_initFields = function () {
    };
    TextAnchor$START_instance = new TextAnchor('START', 0);
    TextAnchor$MIDDLE_instance = new TextAnchor('MIDDLE', 1);
    TextAnchor$END_instance = new TextAnchor('END', 2);
  }
  var TextAnchor$START_instance;
  function TextAnchor$START_getInstance() {
    TextAnchor_initFields();
    return TextAnchor$START_instance;
  }
  var TextAnchor$MIDDLE_instance;
  function TextAnchor$MIDDLE_getInstance() {
    TextAnchor_initFields();
    return TextAnchor$MIDDLE_instance;
  }
  var TextAnchor$END_instance;
  function TextAnchor$END_getInstance() {
    TextAnchor_initFields();
    return TextAnchor$END_instance;
  }
  TextAnchor.$metadata$ = {kind: Kind_CLASS, simpleName: 'TextAnchor', interfaces: [Enum]};
  function TextAnchor$values() {
    return [TextAnchor$START_getInstance(), TextAnchor$MIDDLE_getInstance(), TextAnchor$END_getInstance()];
  }
  TextAnchor.values = TextAnchor$values;
  function TextAnchor$valueOf(name) {
    switch (name) {
      case 'START':
        return TextAnchor$START_getInstance();
      case 'MIDDLE':
        return TextAnchor$MIDDLE_getInstance();
      case 'END':
        return TextAnchor$END_getInstance();
      default:throwISE('No enum constant io.data2viz.viz.TextAnchor.' + name);
    }
  }
  TextAnchor.valueOf_61zpoe$ = TextAnchor$valueOf;
  function TextAlignmentBaseline(name, ordinal) {
    Enum.call(this);
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function TextAlignmentBaseline_initFields() {
    TextAlignmentBaseline_initFields = function () {
    };
    TextAlignmentBaseline$HANGING_instance = new TextAlignmentBaseline('HANGING', 0);
    TextAlignmentBaseline$MIDDLE_instance = new TextAlignmentBaseline('MIDDLE', 1);
    TextAlignmentBaseline$BASELINE_instance = new TextAlignmentBaseline('BASELINE', 2);
  }
  var TextAlignmentBaseline$HANGING_instance;
  function TextAlignmentBaseline$HANGING_getInstance() {
    TextAlignmentBaseline_initFields();
    return TextAlignmentBaseline$HANGING_instance;
  }
  var TextAlignmentBaseline$MIDDLE_instance;
  function TextAlignmentBaseline$MIDDLE_getInstance() {
    TextAlignmentBaseline_initFields();
    return TextAlignmentBaseline$MIDDLE_instance;
  }
  var TextAlignmentBaseline$BASELINE_instance;
  function TextAlignmentBaseline$BASELINE_getInstance() {
    TextAlignmentBaseline_initFields();
    return TextAlignmentBaseline$BASELINE_instance;
  }
  TextAlignmentBaseline.$metadata$ = {kind: Kind_CLASS, simpleName: 'TextAlignmentBaseline', interfaces: [Enum]};
  function TextAlignmentBaseline$values() {
    return [TextAlignmentBaseline$HANGING_getInstance(), TextAlignmentBaseline$MIDDLE_getInstance(), TextAlignmentBaseline$BASELINE_getInstance()];
  }
  TextAlignmentBaseline.values = TextAlignmentBaseline$values;
  function TextAlignmentBaseline$valueOf(name) {
    switch (name) {
      case 'HANGING':
        return TextAlignmentBaseline$HANGING_getInstance();
      case 'MIDDLE':
        return TextAlignmentBaseline$MIDDLE_getInstance();
      case 'BASELINE':
        return TextAlignmentBaseline$BASELINE_getInstance();
      default:throwISE('No enum constant io.data2viz.viz.TextAlignmentBaseline.' + name);
    }
  }
  TextAlignmentBaseline.valueOf_61zpoe$ = TextAlignmentBaseline$valueOf;
  function Shape() {
  }
  Shape.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Shape', interfaces: [HasStroke, HasFill]};
  function HasStroke() {
  }
  HasStroke.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'HasStroke', interfaces: []};
  function HasFill() {
  }
  HasFill.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'HasFill', interfaces: []};
  var ids;
  function nextId(name) {
    var tmp$;
    return name + (tmp$ = ids, ids = tmp$ + 1 | 0, tmp$);
  }
  function get_defs($receiver) {
    var tmp$;
    var svg_0 = svg($receiver);
    var $receiver_0 = asList(svg_0.childNodes);
    var destination = ArrayList_init();
    var tmp$_0;
    tmp$_0 = $receiver_0.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      if (Kotlin.isType(element, Element))
        destination.add_11rb$(element);
    }
    var firstOrNull$result;
    firstOrNull$break: do {
      var tmp$_1;
      tmp$_1 = destination.iterator();
      while (tmp$_1.hasNext()) {
        var element_0 = tmp$_1.next();
        if (equals(element_0.localName, 'defs')) {
          firstOrNull$result = element_0;
          break firstOrNull$break;
        }
      }
      firstOrNull$result = null;
    }
     while (false);
    var defs = firstOrNull$result;
    if (defs == null) {
      var newDefs = createSVGElement('defs');
      svg_0.appendChild(newDefs);
      tmp$ = newDefs;
    }
     else {
      tmp$ = defs;
    }
    return tmp$;
  }
  function FillDelegate() {
    this.start = null;
    this.end = null;
    this.iterator = null;
    this.element_zb3tuy$_0 = this.element_zb3tuy$_0;
  }
  Object.defineProperty(FillDelegate.prototype, 'element_0', {get: function () {
    if (this.element_zb3tuy$_0 == null)
      return throwUPAE('element');
    return this.element_zb3tuy$_0;
  }, set: function (element) {
    this.element_zb3tuy$_0 = element;
  }});
  FillDelegate.prototype.setPercent_14dthe$ = function (percent) {
    var tmp$;
    var value = toString((tmp$ = this.iterator) != null ? tmp$(percent) : null);
    this.element_0.setAttribute('fill', value);
  };
  FillDelegate.prototype.getValue_e9ghuv$ = function (domElement, property) {
    var tmp$;
    return (tmp$ = domElement.domElement.getAttribute('fill')) != null ? get_color(tmp$) : null;
  };
  FillDelegate.prototype.setValue_65b8m8$ = function (wrapper, property, value) {
    var tmp$, tmp$_0, tmp$_1;
    if ((tmp$_1 = (tmp$_0 = Kotlin.isType(tmp$ = wrapper, StateableElement) ? tmp$ : null) != null ? tmp$_0.stateManager : null) != null) {
      var tmp$_2, tmp$_3;
      if (tmp$_1.status === StateManagerStatus$RECORD_getInstance()) {
        this.element_0 = wrapper.domElement;
        this.start = ensureNotNull((tmp$_2 = this.element_0.getAttribute('fill')) != null ? get_color(tmp$_2) : null);
        this.end = Kotlin.isType(tmp$_3 = value, Color) ? tmp$_3 : throwCCE();
        tmp$_1.addStateProperty_z6ptt4$(this);
        this.iterator = interpolateRgb(ensureNotNull(this.start), ensureNotNull(this.end));
        return;
      }
    }
    if (value == null)
      wrapper.domElement.setAttribute('fill', 'none');
    else if (Kotlin.isType(value, LinearGradient))
      addLinearGradient(wrapper.domElement, value, 'fill');
    else if (Kotlin.isType(value, RadialGradient))
      setRadialGradient(wrapper.domElement, value, 'fill');
    else
      wrapper.domElement.setAttribute('fill', value.toString());
  };
  FillDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'FillDelegate', interfaces: [StateProperty]};
  function addLinearGradient(element, linearGradient, attribute) {
    var id = nextId('LinearGradient');
    element.setAttribute(attribute, 'url(#' + id + ')');
    var $receiver = createSVGElement('linearGradient');
    $receiver.setAttribute('id', id);
    $receiver.setAttribute('gradientUnits', 'userSpaceOnUse');
    $receiver.setAttribute('x1', linearGradient.x1.toString());
    $receiver.setAttribute('y1', linearGradient.y1.toString());
    $receiver.setAttribute('x2', linearGradient.x2.toString());
    $receiver.setAttribute('y2', linearGradient.y2.toString());
    var tmp$;
    tmp$ = linearGradient.colorStops.iterator();
    while (tmp$.hasNext()) {
      var element_0 = tmp$.next();
      var $receiver_0 = createSVGElement('stop');
      $receiver_0.setAttribute('offset', (100 * element_0.percent).toString() + '%');
      $receiver_0.setAttribute('stop-color', element_0.color.toString());
      var stop = $receiver_0;
      $receiver.appendChild(stop);
    }
    var linearGradientElement = $receiver;
    get_defs(element).appendChild(linearGradientElement);
  }
  function setRadialGradient(element, gradient, attribute) {
    var gradientElement;
    if (gradient.gradientId != null) {
      var gradientId = gradient.gradientId;
      gradientElement = ensureNotNull(document.querySelector('#' + gradientId));
      element.setAttribute(attribute, 'url(#' + gradientId + ')');
    }
     else {
      var id = nextId('RadialGradient');
      gradient.gradientId = id;
      element.setAttribute(attribute, 'url(#' + id + ')');
      var $receiver = createSVGElement('radialGradient');
      $receiver.setAttribute('id', id);
      $receiver.setAttribute('gradientUnits', 'userSpaceOnUse');
      var tmp$;
      tmp$ = gradient.colorStops.iterator();
      while (tmp$.hasNext()) {
        var element_0 = tmp$.next();
        var $receiver_0 = createSVGElement('stop');
        $receiver_0.setAttribute('offset', (100 * element_0.percent).toString() + '%');
        $receiver_0.setAttribute('stop-color', element_0.color.toString());
        var stop = $receiver_0;
        $receiver.appendChild(stop);
      }
      gradientElement = $receiver;
      get_defs(element).appendChild(gradientElement);
    }
    var $receiver_1 = gradientElement;
    $receiver_1.setAttribute('cx', gradient.cx.toString());
    $receiver_1.setAttribute('cy', gradient.cy.toString());
    $receiver_1.setAttribute('r', gradient.r.toString());
  }
  function StrokeDelegate(element) {
    this.element = element;
  }
  Object.defineProperty(StrokeDelegate.prototype, 'stroke', {get: function () {
    var tmp$;
    return (tmp$ = this.element.getAttribute('stroke')) != null ? get_color(tmp$) : null;
  }, set: function (value) {
    if (value == null)
      this.element.setAttribute('stroke', 'none');
    else if (Kotlin.isType(value, LinearGradient))
      addLinearGradient(this.element, value, 'stroke');
    else if (Kotlin.isType(value, RadialGradient))
      setRadialGradient(this.element, value, 'stroke');
    else
      this.element.setAttribute('stroke', value.toString());
  }});
  Object.defineProperty(StrokeDelegate.prototype, 'strokeWidth', {get: function () {
    var tmp$;
    return (tmp$ = this.element.getAttribute('stroke-width')) != null ? toDouble(tmp$) : null;
  }, set: function (value) {
    var tmp$;
    this.element.setAttribute('stroke-width', (tmp$ = value != null ? value.toString() : null) != null ? tmp$ : '');
  }});
  StrokeDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'StrokeDelegate', interfaces: [HasStroke]};
  function DoubleAttributePropertyDelegate() {
    this.propName = null;
    this.stateTarget_fajve9$_0 = this.stateTarget_fajve9$_0;
    this.startState_0 = null;
    this.endState_0 = null;
  }
  Object.defineProperty(DoubleAttributePropertyDelegate.prototype, 'stateTarget_0', {get: function () {
    if (this.stateTarget_fajve9$_0 == null)
      return throwUPAE('stateTarget');
    return this.stateTarget_fajve9$_0;
  }, set: function (stateTarget) {
    this.stateTarget_fajve9$_0 = stateTarget;
  }});
  DoubleAttributePropertyDelegate.prototype.setPercent_14dthe$ = function (percent) {
    this.stateTarget_0.setAttribute(ensureNotNull(this.propName), (ensureNotNull(this.startState_0) + percent * (ensureNotNull(this.endState_0) - ensureNotNull(this.startState_0))).toString());
  };
  DoubleAttributePropertyDelegate.prototype.getValue_e9ghuv$ = function (elementWrapper, property) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    tmp$_0 = elementWrapper.domElement;
    var tmp$_3;
    if ((tmp$ = this.propName) != null)
      tmp$_3 = tmp$;
    else {
      var $receiver = propertyMapping;
      var key = property.callableName;
      var tmp$_4;
      var $receiver_0 = (tmp$_4 = $receiver.get_11rb$(key)) != null ? tmp$_4 : property.callableName;
      this.propName = $receiver_0;
      tmp$_3 = $receiver_0;
    }
    return (tmp$_2 = (tmp$_1 = tmp$_0.getAttribute(tmp$_3)) != null ? toDouble(tmp$_1) : null) != null ? tmp$_2 : 0.0;
  };
  DoubleAttributePropertyDelegate.prototype.setValue_5t5qt5$ = function (element, property, d) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    if ((tmp$_0 = (Kotlin.isType(tmp$ = element, StateableElement) ? tmp$ : throwCCE()).stateManager) != null) {
      if (tmp$_0.status === StateManagerStatus$RECORD_getInstance()) {
        this.stateTarget_0 = element.domElement;
        this.startState_0 = this.getValue_e9ghuv$(element, property);
        this.endState_0 = d;
        tmp$_0.addStateProperty_z6ptt4$(this);
        return;
      }
    }
    tmp$_2 = element.domElement;
    var tmp$_3;
    if ((tmp$_1 = this.propName) != null)
      tmp$_3 = tmp$_1;
    else {
      var $receiver = propertyMapping;
      var key = property.callableName;
      var tmp$_4;
      var $receiver_0 = (tmp$_4 = $receiver.get_11rb$(key)) != null ? tmp$_4 : property.callableName;
      this.propName = $receiver_0;
      tmp$_3 = $receiver_0;
    }
    tmp$_2.setAttribute(tmp$_3, d.toString());
  };
  DoubleAttributePropertyDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'DoubleAttributePropertyDelegate', interfaces: [StateProperty]};
  function toViz($receiver) {
    var tmp$;
    switch ((Kotlin.isType(tmp$ = $receiver, Element) ? tmp$ : throwCCE()).nodeName) {
      case 'g':
        return new ParentElement($receiver);
      case 'line':
        return new LineDOM($receiver);
      case 'rect':
        return new RectDOM($receiver);
      case 'circle':
        return new CircleDOM($receiver);
      case 'text':
        return new TextDOM($receiver);
      default:throw IllegalArgumentException_init('Unknown type as VizElement :: ' + $receiver);
    }
  }
  function newRect() {
    return new RectDOM();
  }
  function newLine() {
    return new LineDOM();
  }
  function newCircle() {
    return new CircleDOM();
  }
  function newGroup() {
    return new ParentElement();
  }
  function newText() {
    return new TextDOM();
  }
  var isBlank = Kotlin.kotlin.text.isBlank_gw00vp$;
  function createSVGElement(name, classes) {
    if (classes === void 0)
      classes = '';
    var $receiver = document.createElementNS('http://www.w3.org/2000/svg', name);
    if (!isBlank(classes))
      $receiver.setAttribute('class', classes);
    return $receiver;
  }
  function selectOrCreateSvg() {
    var tmp$, tmp$_0;
    var svgElement = (tmp$ = document.querySelector('svg')) == null || Kotlin.isType(tmp$, SVGElement) ? tmp$ : throwCCE();
    if (svgElement == null) {
      svgElement = Kotlin.isType(tmp$_0 = createSVGElement('svg'), SVGElement) ? tmp$_0 : throwCCE();
      ensureNotNull(document.querySelector('body')).append(svgElement);
    }
    return svgElement;
  }
  function svg$parent(child, predicate) {
    var parent = child.parentElement;
    while (parent != null && !predicate(parent)) {
      parent = parent.parentElement;
    }
    if (parent == null)
      throw IllegalArgumentException_init('No parent matching the predicate');
    return parent;
  }
  function svg$lambda(it) {
    return equals(it.localName, 'svg');
  }
  function svg($receiver) {
    var parent = svg$parent;
    return parent($receiver, svg$lambda);
  }
  function DOMVizElement() {
  }
  DOMVizElement.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'DOMVizElement', interfaces: []};
  var IllegalStateException_init = Kotlin.kotlin.IllegalStateException_init_pdl1vj$;
  function ParentElement(domElement) {
    if (domElement === void 0)
      domElement = createSVGElement('g');
    this.domElement_jnue8a$_0 = domElement;
    this.$delegate_f1rrd0$_0 = new StyledDelegate(domElement);
    this.$delegate_f1rrd0$_1 = new TransformableDelegate(domElement);
    if (!equals(this.domElement.namespaceURI, 'http://www.w3.org/2000/svg')) {
      var message = 'Check failed.';
      throw IllegalStateException_init(message.toString());
    }
  }
  Object.defineProperty(ParentElement.prototype, 'domElement', {get: function () {
    return this.domElement_jnue8a$_0;
  }});
  ParentElement.prototype.add_28ft1f$ = function (vizElement) {
    var tmp$;
    if (Kotlin.isType(vizElement, PathDOM)) {
      var element = createSVGElement('path');
      this.domElement.append(element);
      element.setAttribute('d', vizElement.svgPath.path);
    }
     else {
      this.domElement.appendChild((Kotlin.isType(tmp$ = vizElement, DOMVizElement) ? tmp$ : throwCCE()).domElement);
    }
  };
  ParentElement.prototype.remove_28ft1f$ = function (vizElement) {
    var tmp$;
    this.domElement.removeChild((Kotlin.isType(tmp$ = vizElement, DOMVizElement) ? tmp$ : throwCCE()).domElement);
  };
  ParentElement.prototype.path_saeswf$ = function (init) {
    var svgPath = new SvgPath();
    var element = createSVGElement('path');
    this.domElement.append(element);
    var item = new PathDOM(element, svgPath);
    init(item);
    element.setAttribute('d', svgPath.path);
    return item;
  };
  ParentElement.prototype.setStyle_61zpoe$ = function (style) {
    this.domElement.setAttribute('style', style);
  };
  ParentElement.prototype.circle_l499yf$ = function (init) {
    var circle = new CircleDOM(createSVGElement('circle'));
    init(circle);
    this.domElement.append(circle.domElement);
    return circle;
  };
  ParentElement.prototype.group_h70734$ = function (init) {
    var group = new ParentElement(createSVGElement('g'));
    init(group);
    this.domElement.append(group.domElement);
    return group;
  };
  ParentElement.prototype.line_sjwiut$ = function (init) {
    var line = new LineDOM();
    init(line);
    this.domElement.append(line.domElement);
    return line;
  };
  ParentElement.prototype.rect_ya4ubp$ = function (init) {
    var rect = new RectDOM();
    init(rect);
    this.domElement.append(rect.domElement);
    return rect;
  };
  ParentElement.prototype.text_vh70u4$ = function (init) {
    var text = new TextDOM();
    init(text);
    this.domElement.append(text.domElement);
    return text;
  };
  ParentElement.prototype.addClass_b1osal$ = function (cssClass) {
    return this.$delegate_f1rrd0$_0.addClass_b1osal$(cssClass);
  };
  ParentElement.prototype.transform_tabxxp$ = function (init) {
    return this.$delegate_f1rrd0$_1.transform_tabxxp$(init);
  };
  ParentElement.$metadata$ = {kind: Kind_CLASS, simpleName: 'ParentElement', interfaces: [DOMVizElement, VizContext, StyledElement, Transformable]};
  function AccessByAttributes() {
  }
  AccessByAttributes.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'AccessByAttributes', interfaces: []};
  function ElementWrapper() {
  }
  ElementWrapper.prototype.setAttribute_jyasbz$ = function (name, value) {
    if (value != null)
      this.domElement.setAttribute(name, value);
    else
      this.domElement.removeAttribute(name);
  };
  ElementWrapper.prototype.getAttribute_61zpoe$ = function (name) {
    return this.domElement.getAttribute(name);
  };
  ElementWrapper.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'ElementWrapper', interfaces: [DOMVizElement, AccessByAttributes]};
  function PathDOM(domElement, svgPath) {
    if (domElement === void 0)
      domElement = createSVGElement('path');
    if (svgPath === void 0)
      svgPath = new SvgPath();
    this.domElement_jh9km7$_0 = domElement;
    this.svgPath = svgPath;
    this.$delegate_ti3tjl$_0 = new StrokeDelegate(domElement);
    this.$delegate_ti3tjl$_1 = new StyledDelegate(domElement);
    this.$delegate_ti3tjl$_2 = new TransformableDelegate(domElement);
    this.fill_9v6cyg$_0 = new FillDelegate();
  }
  Object.defineProperty(PathDOM.prototype, 'domElement', {get: function () {
    return this.domElement_jh9km7$_0;
  }});
  var PathDOM$fill_metadata = new PropertyMetadata('fill');
  Object.defineProperty(PathDOM.prototype, 'fill', {get: function () {
    return this.fill_9v6cyg$_0.getValue_e9ghuv$(this, PathDOM$fill_metadata);
  }, set: function (fill) {
    this.fill_9v6cyg$_0.setValue_65b8m8$(this, PathDOM$fill_metadata, fill);
  }});
  PathDOM.prototype.arc_6p3vsx$$default = function (centerX, centerY, radius, startAngle, endAngle, counterClockWise) {
    return this.svgPath.arc_6p3vsx$$default(centerX, centerY, radius, startAngle, endAngle, counterClockWise);
  };
  PathDOM.prototype.arcTo_1lq62i$ = function (fromX, fromY, toX, toY, radius) {
    return this.svgPath.arcTo_1lq62i$(fromX, fromY, toX, toY, radius);
  };
  PathDOM.prototype.bezierCurveTo_15yvbs$ = function (x1, y1, x2, y2, x, y) {
    return this.svgPath.bezierCurveTo_15yvbs$(x1, y1, x2, y2, x, y);
  };
  PathDOM.prototype.closePath = function () {
    return this.svgPath.closePath();
  };
  PathDOM.prototype.lineTo_lu1900$ = function (x, y) {
    return this.svgPath.lineTo_lu1900$(x, y);
  };
  PathDOM.prototype.moveTo_lu1900$ = function (x, y) {
    return this.svgPath.moveTo_lu1900$(x, y);
  };
  PathDOM.prototype.quadraticCurveTo_6y0v78$ = function (x1, y1, x, y) {
    return this.svgPath.quadraticCurveTo_6y0v78$(x1, y1, x, y);
  };
  PathDOM.prototype.rect_6y0v78$ = function (x, y, w, h) {
    return this.svgPath.rect_6y0v78$(x, y, w, h);
  };
  Object.defineProperty(PathDOM.prototype, 'stroke', {get: function () {
    return this.$delegate_ti3tjl$_0.stroke;
  }, set: function (tmp$) {
    this.$delegate_ti3tjl$_0.stroke = tmp$;
  }});
  Object.defineProperty(PathDOM.prototype, 'strokeWidth', {get: function () {
    return this.$delegate_ti3tjl$_0.strokeWidth;
  }, set: function (tmp$) {
    this.$delegate_ti3tjl$_0.strokeWidth = tmp$;
  }});
  PathDOM.prototype.addClass_b1osal$ = function (cssClass) {
    return this.$delegate_ti3tjl$_1.addClass_b1osal$(cssClass);
  };
  PathDOM.prototype.transform_tabxxp$ = function (init) {
    return this.$delegate_ti3tjl$_2.transform_tabxxp$(init);
  };
  PathDOM.$metadata$ = {kind: Kind_CLASS, simpleName: 'PathDOM', interfaces: [Transformable, StyledElement, ElementWrapper, PathVizElement, PathAdapter, HasStroke, HasFill]};
  function CircleDOM(domElement) {
    if (domElement === void 0)
      domElement = createSVGElement('circle');
    this.domElement_sgpzva$_0 = domElement;
    this.$delegate_8tuvms$_0 = new StrokeDelegate(domElement);
    this.$delegate_8tuvms$_1 = new StyledDelegate(domElement);
    this.$delegate_8tuvms$_2 = new TransformableDelegate(domElement);
    this.stateManager_846q5o$_0 = null;
    this.fill_biotrn$_0 = new FillDelegate();
    this.cx_fj7w85$_0 = new DoubleAttributePropertyDelegate();
    this.cy_fj7w7a$_0 = new DoubleAttributePropertyDelegate();
    this.radius_tyis82$_0 = new DoubleAttributePropertyDelegate();
  }
  Object.defineProperty(CircleDOM.prototype, 'domElement', {get: function () {
    return this.domElement_sgpzva$_0;
  }});
  Object.defineProperty(CircleDOM.prototype, 'stateManager', {get: function () {
    return this.stateManager_846q5o$_0;
  }, set: function (stateManager) {
    this.stateManager_846q5o$_0 = stateManager;
  }});
  var CircleDOM$fill_metadata = new PropertyMetadata('fill');
  Object.defineProperty(CircleDOM.prototype, 'fill', {get: function () {
    return this.fill_biotrn$_0.getValue_e9ghuv$(this, CircleDOM$fill_metadata);
  }, set: function (fill) {
    this.fill_biotrn$_0.setValue_65b8m8$(this, CircleDOM$fill_metadata, fill);
  }});
  var CircleDOM$cx_metadata = new PropertyMetadata('cx');
  Object.defineProperty(CircleDOM.prototype, 'cx', {get: function () {
    return this.cx_fj7w85$_0.getValue_e9ghuv$(this, CircleDOM$cx_metadata);
  }, set: function (cx) {
    this.cx_fj7w85$_0.setValue_5t5qt5$(this, CircleDOM$cx_metadata, cx);
  }});
  var CircleDOM$cy_metadata = new PropertyMetadata('cy');
  Object.defineProperty(CircleDOM.prototype, 'cy', {get: function () {
    return this.cy_fj7w7a$_0.getValue_e9ghuv$(this, CircleDOM$cy_metadata);
  }, set: function (cy) {
    this.cy_fj7w7a$_0.setValue_5t5qt5$(this, CircleDOM$cy_metadata, cy);
  }});
  var CircleDOM$radius_metadata = new PropertyMetadata('radius');
  Object.defineProperty(CircleDOM.prototype, 'radius', {get: function () {
    return this.radius_tyis82$_0.getValue_e9ghuv$(this, CircleDOM$radius_metadata);
  }, set: function (radius) {
    this.radius_tyis82$_0.setValue_5t5qt5$(this, CircleDOM$radius_metadata, radius);
  }});
  Object.defineProperty(CircleDOM.prototype, 'stroke', {get: function () {
    return this.$delegate_8tuvms$_0.stroke;
  }, set: function (tmp$) {
    this.$delegate_8tuvms$_0.stroke = tmp$;
  }});
  Object.defineProperty(CircleDOM.prototype, 'strokeWidth', {get: function () {
    return this.$delegate_8tuvms$_0.strokeWidth;
  }, set: function (tmp$) {
    this.$delegate_8tuvms$_0.strokeWidth = tmp$;
  }});
  CircleDOM.prototype.addClass_b1osal$ = function (cssClass) {
    return this.$delegate_8tuvms$_1.addClass_b1osal$(cssClass);
  };
  CircleDOM.prototype.transform_tabxxp$ = function (init) {
    return this.$delegate_8tuvms$_2.transform_tabxxp$(init);
  };
  CircleDOM.$metadata$ = {kind: Kind_CLASS, simpleName: 'CircleDOM', interfaces: [Circle, StyledElement, Transformable, HasStroke, HasFill, ElementWrapper]};
  function LineDOM(domElement) {
    if (domElement === void 0)
      domElement = createSVGElement('line');
    this.domElement_8lnhrm$_0 = domElement;
    this.$delegate_dhklts$_0 = new StrokeDelegate(domElement);
    this.$delegate_dhklts$_1 = new StyledDelegate(domElement);
    this.$delegate_dhklts$_2 = new TransformableDelegate(domElement);
    this.fill_lbjmeh$_0 = new FillDelegate();
    this.x1_g0lrkd$_0 = new DoubleAttributePropertyDelegate();
    this.y1_g0lqto$_0 = new DoubleAttributePropertyDelegate();
    this.x2_g0lrji$_0 = new DoubleAttributePropertyDelegate();
    this.y2_g0lqst$_0 = new DoubleAttributePropertyDelegate();
  }
  Object.defineProperty(LineDOM.prototype, 'domElement', {get: function () {
    return this.domElement_8lnhrm$_0;
  }});
  var LineDOM$fill_metadata = new PropertyMetadata('fill');
  Object.defineProperty(LineDOM.prototype, 'fill', {get: function () {
    return this.fill_lbjmeh$_0.getValue_e9ghuv$(this, LineDOM$fill_metadata);
  }, set: function (fill) {
    this.fill_lbjmeh$_0.setValue_65b8m8$(this, LineDOM$fill_metadata, fill);
  }});
  var LineDOM$x1_metadata = new PropertyMetadata('x1');
  Object.defineProperty(LineDOM.prototype, 'x1', {get: function () {
    return this.x1_g0lrkd$_0.getValue_e9ghuv$(this, LineDOM$x1_metadata);
  }, set: function (x1) {
    this.x1_g0lrkd$_0.setValue_5t5qt5$(this, LineDOM$x1_metadata, x1);
  }});
  var LineDOM$y1_metadata = new PropertyMetadata('y1');
  Object.defineProperty(LineDOM.prototype, 'y1', {get: function () {
    return this.y1_g0lqto$_0.getValue_e9ghuv$(this, LineDOM$y1_metadata);
  }, set: function (y1) {
    this.y1_g0lqto$_0.setValue_5t5qt5$(this, LineDOM$y1_metadata, y1);
  }});
  var LineDOM$x2_metadata = new PropertyMetadata('x2');
  Object.defineProperty(LineDOM.prototype, 'x2', {get: function () {
    return this.x2_g0lrji$_0.getValue_e9ghuv$(this, LineDOM$x2_metadata);
  }, set: function (x2) {
    this.x2_g0lrji$_0.setValue_5t5qt5$(this, LineDOM$x2_metadata, x2);
  }});
  var LineDOM$y2_metadata = new PropertyMetadata('y2');
  Object.defineProperty(LineDOM.prototype, 'y2', {get: function () {
    return this.y2_g0lqst$_0.getValue_e9ghuv$(this, LineDOM$y2_metadata);
  }, set: function (y2) {
    this.y2_g0lqst$_0.setValue_5t5qt5$(this, LineDOM$y2_metadata, y2);
  }});
  Object.defineProperty(LineDOM.prototype, 'stroke', {get: function () {
    return this.$delegate_dhklts$_0.stroke;
  }, set: function (tmp$) {
    this.$delegate_dhklts$_0.stroke = tmp$;
  }});
  Object.defineProperty(LineDOM.prototype, 'strokeWidth', {get: function () {
    return this.$delegate_dhklts$_0.strokeWidth;
  }, set: function (tmp$) {
    this.$delegate_dhklts$_0.strokeWidth = tmp$;
  }});
  LineDOM.prototype.addClass_b1osal$ = function (cssClass) {
    return this.$delegate_dhklts$_1.addClass_b1osal$(cssClass);
  };
  LineDOM.prototype.transform_tabxxp$ = function (init) {
    return this.$delegate_dhklts$_2.transform_tabxxp$(init);
  };
  LineDOM.$metadata$ = {kind: Kind_CLASS, simpleName: 'LineDOM', interfaces: [Line, StyledElement, Transformable, HasStroke, HasFill, ElementWrapper]};
  function RectDOM(domElement) {
    if (domElement === void 0)
      domElement = createSVGElement('rect');
    this.domElement_qxa9tq$_0 = domElement;
    this.$delegate_1hqe8g$_0 = new StrokeDelegate(domElement);
    this.$delegate_1hqe8g$_1 = new StyledDelegate(domElement);
    this.$delegate_1hqe8g$_2 = new TransformableDelegate(domElement);
    this.stateManager_yw0f0g$_0 = null;
    this.fill_mays3r$_0 = new FillDelegate();
    this.x_dg6hs$_0 = new DoubleAttributePropertyDelegate();
    this.y_dg6in$_0 = new DoubleAttributePropertyDelegate();
    this.width_qwt0eq$_0 = new DoubleAttributePropertyDelegate();
    this.height_r0n6gb$_0 = new DoubleAttributePropertyDelegate();
    this.rx_bkxidy$_0 = new DoubleAttributePropertyDelegate();
    this.ry_bkxiet$_0 = new DoubleAttributePropertyDelegate();
  }
  Object.defineProperty(RectDOM.prototype, 'domElement', {get: function () {
    return this.domElement_qxa9tq$_0;
  }});
  Object.defineProperty(RectDOM.prototype, 'stateManager', {get: function () {
    return this.stateManager_yw0f0g$_0;
  }, set: function (stateManager) {
    this.stateManager_yw0f0g$_0 = stateManager;
  }});
  var RectDOM$fill_metadata = new PropertyMetadata('fill');
  Object.defineProperty(RectDOM.prototype, 'fill', {get: function () {
    return this.fill_mays3r$_0.getValue_e9ghuv$(this, RectDOM$fill_metadata);
  }, set: function (fill) {
    this.fill_mays3r$_0.setValue_65b8m8$(this, RectDOM$fill_metadata, fill);
  }});
  var RectDOM$x_metadata = new PropertyMetadata('x');
  Object.defineProperty(RectDOM.prototype, 'x', {get: function () {
    return this.x_dg6hs$_0.getValue_e9ghuv$(this, RectDOM$x_metadata);
  }, set: function (x) {
    this.x_dg6hs$_0.setValue_5t5qt5$(this, RectDOM$x_metadata, x);
  }});
  var RectDOM$y_metadata = new PropertyMetadata('y');
  Object.defineProperty(RectDOM.prototype, 'y', {get: function () {
    return this.y_dg6in$_0.getValue_e9ghuv$(this, RectDOM$y_metadata);
  }, set: function (y) {
    this.y_dg6in$_0.setValue_5t5qt5$(this, RectDOM$y_metadata, y);
  }});
  var RectDOM$width_metadata = new PropertyMetadata('width');
  Object.defineProperty(RectDOM.prototype, 'width', {get: function () {
    return this.width_qwt0eq$_0.getValue_e9ghuv$(this, RectDOM$width_metadata);
  }, set: function (width) {
    this.width_qwt0eq$_0.setValue_5t5qt5$(this, RectDOM$width_metadata, width);
  }});
  var RectDOM$height_metadata = new PropertyMetadata('height');
  Object.defineProperty(RectDOM.prototype, 'height', {get: function () {
    return this.height_r0n6gb$_0.getValue_e9ghuv$(this, RectDOM$height_metadata);
  }, set: function (height) {
    this.height_r0n6gb$_0.setValue_5t5qt5$(this, RectDOM$height_metadata, height);
  }});
  var RectDOM$rx_metadata = new PropertyMetadata('rx');
  Object.defineProperty(RectDOM.prototype, 'rx', {get: function () {
    return this.rx_bkxidy$_0.getValue_e9ghuv$(this, RectDOM$rx_metadata);
  }, set: function (rx) {
    this.rx_bkxidy$_0.setValue_5t5qt5$(this, RectDOM$rx_metadata, rx);
  }});
  var RectDOM$ry_metadata = new PropertyMetadata('ry');
  Object.defineProperty(RectDOM.prototype, 'ry', {get: function () {
    return this.ry_bkxiet$_0.getValue_e9ghuv$(this, RectDOM$ry_metadata);
  }, set: function (ry) {
    this.ry_bkxiet$_0.setValue_5t5qt5$(this, RectDOM$ry_metadata, ry);
  }});
  Object.defineProperty(RectDOM.prototype, 'stroke', {get: function () {
    return this.$delegate_1hqe8g$_0.stroke;
  }, set: function (tmp$) {
    this.$delegate_1hqe8g$_0.stroke = tmp$;
  }});
  Object.defineProperty(RectDOM.prototype, 'strokeWidth', {get: function () {
    return this.$delegate_1hqe8g$_0.strokeWidth;
  }, set: function (tmp$) {
    this.$delegate_1hqe8g$_0.strokeWidth = tmp$;
  }});
  RectDOM.prototype.addClass_b1osal$ = function (cssClass) {
    return this.$delegate_1hqe8g$_1.addClass_b1osal$(cssClass);
  };
  RectDOM.prototype.transform_tabxxp$ = function (init) {
    return this.$delegate_1hqe8g$_2.transform_tabxxp$(init);
  };
  RectDOM.$metadata$ = {kind: Kind_CLASS, simpleName: 'RectDOM', interfaces: [Rect, StyledElement, Transformable, HasStroke, HasFill, ElementWrapper]};
  var propertyMapping;
  function TransformableDelegate(element) {
    this.element = element;
  }
  TransformableDelegate.prototype.transform_tabxxp$ = function (init) {
    var tmp$ = this.element;
    var $receiver = new TransformSvg();
    init($receiver);
    tmp$.setAttribute('transform', $receiver.toCommand_8be2vx$());
  };
  TransformableDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'TransformableDelegate', interfaces: [Transformable]};
  var LinkedHashMap_init = Kotlin.kotlin.collections.LinkedHashMap_init_q3lmfv$;
  function TransformSvg() {
    this.commands_0 = LinkedHashMap_init();
  }
  TransformSvg.prototype.translate_fl8io8$ = function (newPoint) {
    this.commands_0.put_xwzc9p$('translate', 'translate(' + newPoint.x + ', ' + newPoint.y + ')');
  };
  TransformSvg.prototype.translate_lu1900$$default = function (x, y) {
    this.commands_0.put_xwzc9p$('translate', 'translate(' + x + ', ' + y + ')');
  };
  TransformSvg.prototype.scale_z8e4lc$ = function (x, y) {
    if (x === void 0)
      x = 1;
    if (y === void 0)
      y = x;
    this.commands_0.put_xwzc9p$('scale', 'scale(' + x + ', ' + y + ')');
  };
  TransformSvg.prototype.skewX_3p81yu$ = function (a) {
    this.commands_0.put_xwzc9p$('skewX', 'skewX(' + a + ')');
  };
  TransformSvg.prototype.skewY_3p81yu$ = function (a) {
    this.commands_0.put_xwzc9p$('skewY', 'skewX(' + a + ')');
  };
  TransformSvg.prototype.rotate_yvo9jy$$default = function (degrees, x, y) {
    this.commands_0.put_xwzc9p$('rotate', 'rotate(' + degrees + ', ' + x + ', ' + y + ')');
  };
  TransformSvg.prototype.toCommand_8be2vx$ = function () {
    return joinToString(this.commands_0.values, ' ');
  };
  TransformSvg.$metadata$ = {kind: Kind_CLASS, simpleName: 'TransformSvg', interfaces: [Transform]};
  function StyledDelegate(element) {
    this.element = element;
  }
  StyledDelegate.prototype.addClass_b1osal$ = function (cssClass) {
    this.element.classList.add(cssClass.name);
  };
  StyledDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'StyledDelegate', interfaces: [StyledElement]};
  function TextDOM(domElement) {
    if (domElement === void 0)
      domElement = createSVGElement('text');
    this.domElement_b19xnr$_0 = domElement;
    this.$delegate_v62n53$_0 = new StyledDelegate(domElement);
    this.$delegate_v62n53$_1 = new TransformableDelegate(domElement);
    this.fill_gtck4w$_0 = new FillDelegate();
    this.x_uwnre1$_0 = new DoubleAttributePropertyDelegate();
    this.y_uwnrew$_0 = new DoubleAttributePropertyDelegate();
  }
  Object.defineProperty(TextDOM.prototype, 'domElement', {get: function () {
    return this.domElement_b19xnr$_0;
  }});
  var TextDOM$fill_metadata = new PropertyMetadata('fill');
  Object.defineProperty(TextDOM.prototype, 'fill', {get: function () {
    return this.fill_gtck4w$_0.getValue_e9ghuv$(this, TextDOM$fill_metadata);
  }, set: function (fill) {
    this.fill_gtck4w$_0.setValue_65b8m8$(this, TextDOM$fill_metadata, fill);
  }});
  Object.defineProperty(TextDOM.prototype, 'baseline', {get: function () {
    var tmp$, tmp$_0;
    var tmp$_1;
    if ((tmp$ = this.getAttribute_61zpoe$('alignment-baseline')) != null) {
      var block$result;
      block$break: do {
        switch (tmp$) {
          case 'hanging':
            block$result = TextAlignmentBaseline$HANGING_getInstance();
            break block$break;
          case 'middle':
            block$result = TextAlignmentBaseline$MIDDLE_getInstance();
            break block$break;
          default:block$result = TextAlignmentBaseline$BASELINE_getInstance();
            break block$break;
        }
      }
       while (false);
      tmp$_1 = block$result;
    }
     else
      tmp$_1 = null;
    return (tmp$_0 = tmp$_1) != null ? tmp$_0 : TextAlignmentBaseline$BASELINE_getInstance();
  }, set: function (value) {
    var tmp$;
    switch (value.name) {
      case 'BASELINE':
        tmp$ = 'baseline';
        break;
      case 'HANGING':
        tmp$ = 'hanging';
        break;
      case 'MIDDLE':
        tmp$ = 'middle';
        break;
      default:tmp$ = Kotlin.noWhenBranchMatched();
        break;
    }
    this.setAttribute_jyasbz$('alignment-baseline', tmp$);
  }});
  Object.defineProperty(TextDOM.prototype, 'anchor', {get: function () {
    var tmp$, tmp$_0;
    var tmp$_1;
    if ((tmp$ = this.getAttribute_61zpoe$('text-anchor')) != null) {
      var block$result;
      block$break: do {
        switch (tmp$) {
          case 'middle':
            block$result = TextAnchor$MIDDLE_getInstance();
            break block$break;
          case 'end':
            block$result = TextAnchor$END_getInstance();
            break block$break;
          default:block$result = TextAnchor$START_getInstance();
            break block$break;
        }
      }
       while (false);
      tmp$_1 = block$result;
    }
     else
      tmp$_1 = null;
    return (tmp$_0 = tmp$_1) != null ? tmp$_0 : TextAnchor$START_getInstance();
  }, set: function (value) {
    var tmp$;
    switch (value.name) {
      case 'START':
        tmp$ = 'start';
        break;
      case 'MIDDLE':
        tmp$ = 'middle';
        break;
      case 'END':
        tmp$ = 'end';
        break;
      default:tmp$ = Kotlin.noWhenBranchMatched();
        break;
    }
    this.setAttribute_jyasbz$('text-anchor', tmp$);
  }});
  Object.defineProperty(TextDOM.prototype, 'textContent', {get: function () {
    var tmp$;
    return (tmp$ = this.domElement.textContent) != null ? tmp$ : '';
  }, set: function (value) {
    this.domElement.textContent = value;
  }});
  var TextDOM$x_metadata = new PropertyMetadata('x');
  Object.defineProperty(TextDOM.prototype, 'x', {get: function () {
    return this.x_uwnre1$_0.getValue_e9ghuv$(this, TextDOM$x_metadata);
  }, set: function (x) {
    this.x_uwnre1$_0.setValue_5t5qt5$(this, TextDOM$x_metadata, x);
  }});
  var TextDOM$y_metadata = new PropertyMetadata('y');
  Object.defineProperty(TextDOM.prototype, 'y', {get: function () {
    return this.y_uwnrew$_0.getValue_e9ghuv$(this, TextDOM$y_metadata);
  }, set: function (y) {
    this.y_uwnrew$_0.setValue_5t5qt5$(this, TextDOM$y_metadata, y);
  }});
  TextDOM.prototype.addClass_b1osal$ = function (cssClass) {
    return this.$delegate_v62n53$_0.addClass_b1osal$(cssClass);
  };
  TextDOM.prototype.transform_tabxxp$ = function (init) {
    return this.$delegate_v62n53$_1.transform_tabxxp$(init);
  };
  TextDOM.$metadata$ = {kind: Kind_CLASS, simpleName: 'TextDOM', interfaces: [Text, StyledElement, HasFill, Transformable, ElementWrapper]};
  var package$io = _.io || (_.io = {});
  var package$data2viz = package$io.data2viz || (package$io.data2viz = {});
  var package$viz = package$data2viz.viz || (package$data2viz.viz = {});
  package$viz.SelectionEnterAccessor = SelectionEnterAccessor;
  package$viz.SelectionUpdateAccessor = SelectionUpdateAccessor;
  package$viz.SelectionExitAccessor = SelectionExitAccessor;
  package$viz.Selection = Selection;
  Object.defineProperty(package$viz, 'circle', {get: function () {
    return circle;
  }});
  package$viz.cssclass = cssclass;
  package$viz.CssClassDelegate = CssClassDelegate;
  package$viz.CssClass = CssClass;
  package$viz.Selector = Selector;
  package$viz.ClassSelector = ClassSelector;
  Object.defineProperty(Combinator, 'CHILDREN', {get: Combinator$CHILDREN_getInstance});
  Object.defineProperty(Combinator, 'DESCENDENT', {get: Combinator$DESCENDENT_getInstance});
  package$viz.Combinator = Combinator;
  package$viz.TypeSelector = TypeSelector;
  Object.defineProperty(StateManagerStatus, 'REST', {get: StateManagerStatus$REST_getInstance});
  Object.defineProperty(StateManagerStatus, 'RECORD', {get: StateManagerStatus$RECORD_getInstance});
  Object.defineProperty(StateManagerStatus, 'UPDATE_PROPERTIES', {get: StateManagerStatus$UPDATE_PROPERTIES_getInstance});
  package$viz.StateManagerStatus = StateManagerStatus;
  package$viz.StateProperty = StateProperty;
  package$viz.VizContext = VizContext;
  package$viz.VizElement = VizElement;
  package$viz.StateableElement = StateableElement;
  package$viz.Group = Group;
  package$viz.Transformable = Transformable;
  package$viz.Transform = Transform;
  package$viz.StyledElement = StyledElement;
  package$viz.PathVizElement = PathVizElement;
  package$viz.Circle = Circle;
  package$viz.Line = Line;
  package$viz.Rect = Rect;
  package$viz.Text = Text;
  Object.defineProperty(TextAnchor, 'START', {get: TextAnchor$START_getInstance});
  Object.defineProperty(TextAnchor, 'MIDDLE', {get: TextAnchor$MIDDLE_getInstance});
  Object.defineProperty(TextAnchor, 'END', {get: TextAnchor$END_getInstance});
  package$viz.TextAnchor = TextAnchor;
  Object.defineProperty(TextAlignmentBaseline, 'HANGING', {get: TextAlignmentBaseline$HANGING_getInstance});
  Object.defineProperty(TextAlignmentBaseline, 'MIDDLE', {get: TextAlignmentBaseline$MIDDLE_getInstance});
  Object.defineProperty(TextAlignmentBaseline, 'BASELINE', {get: TextAlignmentBaseline$BASELINE_getInstance});
  package$viz.TextAlignmentBaseline = TextAlignmentBaseline;
  package$viz.Shape = Shape;
  package$viz.HasStroke = HasStroke;
  package$viz.HasFill = HasFill;
  package$viz.FillDelegate = FillDelegate;
  package$viz.addLinearGradient_9p1rz7$ = addLinearGradient;
  package$viz.setRadialGradient_hbfe59$ = setRadialGradient;
  package$viz.StrokeDelegate = StrokeDelegate;
  package$viz.DoubleAttributePropertyDelegate = DoubleAttributePropertyDelegate;
  package$viz.DOMVizElement = DOMVizElement;
  package$viz.toViz_asww5s$ = toViz;
  package$viz.newCircle = newCircle;
  package$viz.newLine = newLine;
  package$viz.newRect = newRect;
  package$viz.newGroup = newGroup;
  package$viz.newText = newText;
  package$viz.createSVGElement_puj7f4$ = createSVGElement;
  package$viz.selectOrCreateSvg = selectOrCreateSvg;
  package$viz.svg_ejp6nk$ = svg;
  package$viz.ParentElement = ParentElement;
  package$viz.AccessByAttributes = AccessByAttributes;
  package$viz.ElementWrapper = ElementWrapper;
  package$viz.PathDOM = PathDOM;
  package$viz.CircleDOM = CircleDOM;
  package$viz.LineDOM = LineDOM;
  package$viz.RectDOM = RectDOM;
  package$viz.TransformableDelegate = TransformableDelegate;
  package$viz.TransformSvg = TransformSvg;
  package$viz.StyledDelegate = StyledDelegate;
  package$viz.TextDOM = TextDOM;
  PathVizElement.prototype.arc_6p3vsx$ = PathAdapter.prototype.arc_6p3vsx$;
  PathDOM.prototype.setAttribute_jyasbz$ = ElementWrapper.prototype.setAttribute_jyasbz$;
  PathDOM.prototype.getAttribute_61zpoe$ = ElementWrapper.prototype.getAttribute_61zpoe$;
  PathDOM.prototype.arc_6p3vsx$ = PathVizElement.prototype.arc_6p3vsx$;
  CircleDOM.prototype.setAttribute_jyasbz$ = ElementWrapper.prototype.setAttribute_jyasbz$;
  CircleDOM.prototype.getAttribute_61zpoe$ = ElementWrapper.prototype.getAttribute_61zpoe$;
  LineDOM.prototype.setAttribute_jyasbz$ = ElementWrapper.prototype.setAttribute_jyasbz$;
  LineDOM.prototype.getAttribute_61zpoe$ = ElementWrapper.prototype.getAttribute_61zpoe$;
  RectDOM.prototype.setAttribute_jyasbz$ = ElementWrapper.prototype.setAttribute_jyasbz$;
  RectDOM.prototype.getAttribute_61zpoe$ = ElementWrapper.prototype.getAttribute_61zpoe$;
  TransformSvg.prototype.translate_lu1900$ = Transform.prototype.translate_lu1900$;
  TransformSvg.prototype.rotate_yvo9jy$ = Transform.prototype.rotate_yvo9jy$;
  TextDOM.prototype.setAttribute_jyasbz$ = ElementWrapper.prototype.setAttribute_jyasbz$;
  TextDOM.prototype.getAttribute_61zpoe$ = ElementWrapper.prototype.getAttribute_61zpoe$;
  circle = new TypeSelector(newCircle());
  line = new TypeSelector(newLine());
  rect = new TypeSelector(newRect());
  text = new TypeSelector(newText());
  axis = cssclass();
  ticks = cssclass();
  blue = cssclass();
  ids = 1;
  propertyMapping = mapOf(to('radius', 'r'));
  return _;
}));

//# sourceMappingURL=d2v-viz-js.js.map



//////////////////
// WEBPACK FOOTER
// ./build/kotlin-js-min/main/d2v-viz-js.js
// module id = 9
// module chunks = 0